import React from 'react'

const SuperAdminDashboards = () => {
  return (
    <div>SuperAdminDashboards</div>
  )
}

export default SuperAdminDashboards